export const dataHooks = {
    GooglePreviewTitle: 'googlePreview-title',
    GooglePreviewDescription: 'googlePreview-description',
    GooglePreviewPreviewUrl: 'googlePreview-previewUrl',
    GooglePreviewSiteName: 'googlePreview-siteName',
    GooglePreviewWebsiteInfo: 'googlePreview-websiteInfo',
    GooglePreviewWebsiteInfoTooltip: 'googlePreview-websiteInfoTooltip',
};
export const DEFAULT_TOOLTIP_PROPS = { enterDelay: 200 };
//# sourceMappingURL=constants.js.map